import React from "react";
import { AiOutlineShopping, AiOutlinePlus, AiOutlineArrowLeft } from "react-icons/ai";
import Header from "../components/header";
import { Link } from "react-router-dom";
import { withRouter } from "../components/withRouter";
import { hostsSettings } from "../configs/app.config";
import moment from "moment";
import { LogoSvg } from "../components/loading";
import ConfirmaitonModal from "../components/confirmation_modal";

class Sales extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sales: [],
      page: 1,
      settings: [],
      confirmation: false,
      isLoading: false,
      deletedRecord: null,
      checkFrame: false,
      checkFrameValue: "",
    };
  }

  getSales() {
    this.setState({ isLoading: true });
    fetch(hostsSettings.apiPage + "/sales/page=" + this.state.page, {
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
      }),
      method: "GET",
      cache: "no-cache",
      mode: "cors",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.error) {
          this.setState((prevState) => ({
            sales: [...prevState.sales, ...res], // Разворачиваем `res` через `...`
            isLoading: false,
          }));
        }
      });
  }

  getSettings() {
    this.setState({ isLoading: true });
    fetch(hostsSettings.apiPage + "/settings", {
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
      }),
      method: "GET",
      cache: "no-cache",
      mode: "cors",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.error) {
          this.setState({ settings: res[0], isLoading: false });
        }
      });
  }

  backAction = () => {
    this.props.navigate("/main");
  };

  additionalAction = () => {
    this.props.navigate("/sales/new");
  };
  getMoreSales() {
    // getMoreSales = () => {
    // const { scrollTop, scrollHeight, clientHeight } = document.documentElement;

    // if (scrollTop + clientHeight >= scrollHeight) {
    //   this.setState({ page: this.state.page + 1 }, this.getSales);
    // }

    this.setState({ page: this.state.page + 1 }, this.getSales);
  }

  confirming_return(id) {
    this.setState({ confirmation: true, deletedRecord: id });
  }

  handleCloseConfirmationAction = () => {
    this.setState({ confirmation: false, checkFrame: false, checkFrameValue: "", deletedRecord: null });
  };

  refund_confirm = () => {
    this.setState({ isLoading: true, confirmation: false });
    fetch(hostsSettings.apiPage + "/sales/" + this.state.deletedRecord + "/refund", {
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
      }),
      method: "DELETE",
      cache: "no-cache",
      mode: "cors",
      credentials: "include",
      body: JSON.stringify({
        cashboxId: this.state.settings.cashboxId,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        this.setState({ deletedRecord: null });
        if (!res.error) {
          this.setState({ sales: [], page: 1 }, this.getSales);
          this.getSettings();
        }
      });
  };

  getCheck(id, type, company, record) {
    fetch(hostsSettings.apiPage + "/sales/" + id + "/receipt/" + type + "/new", {
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
      }),
      method: "POST",
      cache: "no-cache",
      mode: "cors",
      credentials: "include",
      body: JSON.stringify({
        cashboxId: this.state.settings.cashboxId,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.data.corrected_date) {
          this.setState({
            checkFrame: true,
            checkFrameValue:
              "https://crm.digitalkassa.ru/show/" + this.state.settings.groupId + "/correction/" + res.rid,
          });
          // window.open(
          //   "https://crm.digitalkassa.ru/show/" + this.state.settings.groupId + "/correction/" + res.rid,
          //   "_blank"
          // );
        } else {
          this.setState({
            checkFrame: true,
            checkFrameValue: "https://crm.digitalkassa.ru/show/" + this.state.settings.groupId + "/" + res.rid,
          });
          // window.open("https://crm.digitalkassa.ru/show/" + this.state.settings.groupId + "/" + res.rid, "_blank");
        }
      });
  }

  openNested(id) {
    document.getElementById("child_order_" + id).style.display =
      document.getElementById("child_order_" + id).style.display == "none" ? "block" : "none";
    document.getElementById("seeChecksBtn_" + id).innerText =
      document.getElementById("seeChecksBtn_" + id).innerText == "Смотреть" ? "Закрыть" : "Смотреть";
  }

  render() {
    return (
      <div>
        <Header
          back={<AiOutlineArrowLeft />}
          additional={<AiOutlinePlus />}
          backAction={this.backAction}
          pageName={"Продажи"}
          additionalAction={this.additionalAction}
        />
        {this.state.isLoading ? (
          <div className="loading_logo">
            <LogoSvg />
          </div>
        ) : (
          ""
        )}
        <div className="sales">
          {this.state.sales.lenght == 0 ? (
            "Список продаж пуст"
          ) : (
            <div>
              {this.state.sales.map((sale, index) => {
                return (
                  <div key={sale.id} className="sale_item">
                    <div className="sale_header">
                      <div className="sale_date">{moment(sale.date).format("DD.MM.YYYY HH:mm")}</div>
                      <div className="sale_price">
                        {sale.status === "open_shift" || sale.status === "close_shift" ? (
                          sale.status === "open_shift" ? (
                            <div className="divSuccess divs">Открытие смены</div>
                          ) : (
                            <div className="divSuccess divs">Закрытие смены</div>
                          )
                        ) : !sale?.children ? (
                          sale.status === "refund" || sale.chType === 2 ? (
                            <div className="divSuccess divs">
                              {sale.corrected_date == null ? "Возврат прихода" : "Возврат прихода/Коррекция"}
                            </div>
                          ) : sale.status === "done" ? (
                            <div className="divSuccess divs">
                              {sale.chType === 4
                                ? "Возврат расхода"
                                : sale.chType === 3
                                ? sale.corrected_date == null
                                  ? "Расход"
                                  : "Расход/Коррекция"
                                : sale.corrected_date == null
                                ? "Приход"
                                : "Приход/Коррекция"}
                            </div>
                          ) : sale.status === "waitB2P" ? (
                            <div className="divProcessing divs">Не оплачен</div>
                          ) : sale.status === "waitQR" ? (
                            <div className="divProcessing divs">В ожидании</div>
                          ) : sale.status === "timeout" || sale.status === "error" ? (
                            sale.error ? (
                              <div className="divError divs">Ошибка</div>
                            ) : (
                              <div className="divError divs">Ошибка</div>
                            )
                          ) : (
                            <div className="divProcessing divs">В процессе</div>
                          )
                        ) : null}
                      </div>
                    </div>
                    {sale.status === "order" ? (
                      <div className="sale_body">
                        <div className="sale_number">Заказ № {sale.id}</div>
                        <div className="sale_client" style={{ margin: 0 }}>
                          Продажа из стороннего сервиса
                        </div>
                      </div>
                    ) : (
                      <div className="sale_body">
                        <div className="sale_number">№ {sale.id}</div>
                        <div className="sale_price">{sale.amount} ₽</div>
                        <div className="sale_client">{sale.customer}</div>
                      </div>
                    )}

                    <div className="sale_footer">
                      {sale.status === "order" ? (
                        <button
                          size="small"
                          id={"seeChecksBtn_" + index}
                          onClick={() => {
                            this.openNested(index);
                          }}
                          style={{ marginLeft: "auto" }}>
                          Смотреть
                        </button>
                      ) : sale.status === "open_shift" ? (
                        <>
                          <button size="small" /*onClick={this.ceOpenShift.bind(this, sale)}*/>
                            Отчёт об открытии смены
                          </button>
                        </>
                      ) : sale.status === "close_shift" ? (
                        <>
                          <button size="small" /*onClick={this.ceCloseShift.bind(this, sale)}*/>
                            Отчёт о закрытии смены
                          </button>
                        </>
                      ) : sale.status === "order" ? (
                        <>
                          {/* <button size="small" onClick={this.ceOpenShowOrder.bind(this, sale, true)} */}
                          {/* Добавить чек к заказу */}
                          {/* </button> */}
                        </>
                      ) : sale.order ? (
                        sale.status === "refund" ? (
                          <>
                            <button size="small" onClick={this.getCheck.bind(this, sale.id_, 2, sale.company_id, sale)}>
                              Чек
                            </button>
                          </>
                        ) : (
                          <>
                            <button size="small" onClick={this.getCheck.bind(this, sale.id_, 1, sale.company_id, sale)}>
                              Чек
                            </button>
                          </>
                        )
                      ) : sale.status === "done" && sale.chType === 1 ? (
                        <>
                          {sale.orgId == 1620 ? (
                            sale.is_user == true ? (
                              <button
                                size="small"
                                onClick={() => {
                                  this.confirming_return(sale.id);
                                }}>
                                Возврат
                              </button>
                            ) : (
                              ""
                            )
                          ) : (
                            <button
                              size="small"
                              onClick={() => {
                                this.confirming_return(sale.id);
                              }}>
                              Возврат
                            </button>
                          )}

                          <button size="small" onClick={this.getCheck.bind(this, sale.id, 1, sale.company_id, sale)}>
                            Чек {sale.chType === 3 ? "расхода" : "прихода"}
                          </button>
                        </>
                      ) : sale.status === "done" && sale.chType === 3 ? (
                        <button size="small" onClick={this.getCheck.bind(this, sale.id, 1, sale.company_id, sale)}>
                          Чек {sale.chType === 3 ? "расхода" : "прихода"}
                        </button>
                      ) : sale.status === "refund" || sale.chType === 2 ? (
                        sale.returnOnly || sale.chType === 2 ? (
                          <>
                            <button size="small" onClick={this.getCheck.bind(this, sale.id, 2, sale.company_id, sale)}>
                              Чек возврата
                            </button>
                          </>
                        ) : (
                          <>
                            <button size="small" onClick={this.getCheck.bind(this, sale.id, 2, sale.company_id, sale)}>
                              Чек возврата
                            </button>
                            <button size="small" onClick={this.getCheck.bind(this, sale.id, 1, sale.company_id, sale)}>
                              Чек {sale.chType === 3 ? "расхода" : "прихода"}
                            </button>
                          </>
                        )
                      ) : sale.chType === 4 ? (
                        <>
                          <button size="small" onClick={this.getCheck.bind(this, sale.id, 2, sale.company_id, sale)}>
                            Чек возврата расхода
                          </button>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    {sale.status === "order"
                      ? sale.children.map((child, index2) => {
                          return (
                            <div
                              className="sale_data_in"
                              style={{
                                borderTop: "1px var(--gray) solid",
                                marginTop: 10,
                                padding: 10,
                                borderRadius: "15px",
                                background: "var(--gray)",
                                display: "none",
                              }}
                              key={"child_order" + index2}
                              id={"child_order_" + index}>
                              <div className="sale_header">
                                <div className="child_date">{moment(child.date).format("DD.MM.YYYY HH:mm")}</div>
                                <div className="child_price">
                                  {child.status === "open_shift" || child.status === "close_shift" ? (
                                    child.status === "open_shift" ? (
                                      <div className="divSuccess divs">Открытие смены</div>
                                    ) : (
                                      <div className="divSuccess divs">Закрытие смены</div>
                                    )
                                  ) : !child?.children ? (
                                    child.status === "refund" || child.chType === 2 ? (
                                      <div className="divSuccess divs">
                                        {child.corrected_date == null ? "Возврат прихода" : "Возврат прихода/Коррекция"}
                                      </div>
                                    ) : child.status === "done" ? (
                                      <div className="divSuccess divs">
                                        {child.chType === 4
                                          ? "Возврат расхода"
                                          : child.chType === 3
                                          ? child.corrected_date == null
                                            ? "Расход"
                                            : "Расход/Коррекция"
                                          : child.corrected_date == null
                                          ? "Приход"
                                          : "Приход/Коррекция"}
                                      </div>
                                    ) : child.status === "waitB2P" ? (
                                      <div className="divProcessing divs">Не оплачен</div>
                                    ) : child.status === "waitQR" ? (
                                      <div className="divProcessing divs">В ожидании</div>
                                    ) : child.status === "timeout" || child.status === "error" ? (
                                      child.error ? (
                                        <div className="divError divs">Ошибка</div>
                                      ) : (
                                        <div className="divError divs">Ошибка</div>
                                      )
                                    ) : (
                                      <div className="divProcessing divs">В процессе</div>
                                    )
                                  ) : null}
                                </div>
                              </div>
                              <div className="sale_number">№ {child.id}</div>
                              <div className="sale_price">{child.amount} ₽</div>
                              <div className="sale_client">{child.customer}</div>
                              <div className="child_footer">
                                {child.status === "order" ? (
                                  <button size="small" style={{ marginLeft: "auto" }}>
                                    Смотреть
                                  </button>
                                ) : child.status === "open_shift" ? (
                                  <>
                                    <button size="small" /*onClick={this.ceOpenShift.bind(this, child)}*/>
                                      Отчёт об открытии смены
                                    </button>
                                  </>
                                ) : child.status === "close_shift" ? (
                                  <>
                                    <button size="small" /*onClick={this.ceCloseShift.bind(this, child)}*/>
                                      Отчёт о закрытии смены
                                    </button>
                                  </>
                                ) : child.status === "order" ? (
                                  <>
                                    {/* <button size="small" onClick={this.ceOpenShowOrder.bind(this, child, true)} */}
                                    {/* Добавить чек к заказу */}
                                    {/* </button> */}
                                  </>
                                ) : child.order ? (
                                  child.status === "refund" ? (
                                    <>
                                      <button
                                        size="small"
                                        onClick={this.getCheck.bind(this, child.id_, 2, child.company_id, child)}>
                                        Чек
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        size="small"
                                        onClick={this.getCheck.bind(this, child.id_, 1, child.company_id, child)}>
                                        Чек
                                      </button>
                                    </>
                                  )
                                ) : child.status === "done" && child.chType === 1 ? (
                                  <>
                                    {child.orgId == 1620 ? (
                                      child.is_user == true ? (
                                        <button
                                          size="small"
                                          onClick={() => {
                                            this.confirming_return(child.id);
                                          }}>
                                          Возврат
                                        </button>
                                      ) : (
                                        ""
                                      )
                                    ) : (
                                      <button
                                        size="small"
                                        onClick={() => {
                                          this.confirming_return(child.id);
                                        }}>
                                        Возврат
                                      </button>
                                    )}

                                    <button
                                      size="small"
                                      onClick={this.getCheck.bind(this, child.id, 1, child.company_id, child)}>
                                      Чек {child.chType === 3 ? "расхода" : "прихода"}
                                    </button>
                                  </>
                                ) : child.status === "done" && child.chType === 3 ? (
                                  <button
                                    size="small"
                                    onClick={this.getCheck.bind(this, child.id, 1, child.company_id, child)}>
                                    Чек {child.chType === 3 ? "расхода" : "прихода"}
                                  </button>
                                ) : child.status === "refund" || child.chType === 2 ? (
                                  child.returnOnly || child.chType === 2 ? (
                                    <>
                                      <button
                                        size="small"
                                        onClick={this.getCheck.bind(this, child.id, 2, child.company_id, child)}>
                                        Чек возврата
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        size="small"
                                        onClick={this.getCheck.bind(this, child.id, 2, child.company_id, child)}>
                                        Чек возврата
                                      </button>
                                      <button
                                        size="small"
                                        onClick={this.getCheck.bind(this, child.id, 1, child.company_id, child)}>
                                        Чек {child.chType === 3 ? "расхода" : "прихода"}
                                      </button>
                                    </>
                                  )
                                ) : child.chType === 4 ? (
                                  <>
                                    <button
                                      size="small"
                                      onClick={this.getCheck.bind(this, child.id, 2, child.company_id, child)}>
                                      Чек возврата расхода
                                    </button>
                                  </>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          );
                        })
                      : ""}
                  </div>
                );
              })}
              {
                this.state.isLoading == true ? (
                  ""
                ) : (
                  <button
                    style={{ marginTop: 15 }}
                    className={"btn btn_tdk"}
                    onClick={() => {
                      this.getMoreSales();
                    }}>
                    <span>Загрузить еще</span>
                  </button>
                )
                // <div className="loadIconDown" style={{ textAlign: 'center' }}>
                //   <LogoSvg /> Загрузить еще
                // </div>
              }
            </div>
          )}
        </div>

        {this.state.confirmation == true ? (
          <ConfirmaitonModal
            closeAction={this.handleCloseConfirmationAction}
            okAction={this.refund_confirm}
            image="🤔"
            title='Операция фискализации чека "Возврат прихода"'
            description="Внимание, данное действие поставит чек в очередь «Возврат прихода». Действительно продолжить?"
            okText="Продолжить"
            cancelText="Отмена"
          />
        ) : (
          ""
        )}

        {this.state.checkFrame == true ? (
          <ConfirmaitonModal
            closeAction={this.handleCloseConfirmationAction}
            title="Просмотр чека"
            iframe={this.state.checkFrameValue}
            cancelText="Закрыть"
          />
        ) : (
          ""
        )}
      </div>
    );
  }

  componentDidMount() {
    this.getSales();
    this.getSettings();
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
}

export default withRouter(Sales);
